import React from 'react';
import cx from 'classnames';
import './styles.scss';
const FlexBox = ({
	flexBoxClass,
	children,
	justifyCenter,
	justifyAround,
	justifyBetween,
	justifyEnd,
	justifyEvenly,
	alignEnd,
	alignCenter,
	alignTop,
	flexColumn,
	tagP,
	tagSPAN,
	w100,
	flexBoxStyle,
	flexWrap,
	onClick,
	onScroll,
	ref,
}) => {
	const className = cx(
		'flex',
		justifyCenter && 'justify-center',
		justifyAround && 'justify-around',
		justifyBetween && 'flex-justify',
		justifyEvenly && 'justify-evenly',
		justifyEnd && 'justify-end',
		alignCenter && 'flex-center',
		alignTop && 'align-top',
		alignEnd && 'align-end',
		flexColumn && 'flex-column',
		flexWrap && 'flex-wrap',
		w100 && 'w-100',
		flexBoxClass,
	);
	return tagP ? (
		<p className={className} onClick={onClick} style={flexBoxStyle}>
			{children}
		</p>
	) : tagSPAN ? (
		<span className={className} onClick={onClick} style={flexBoxStyle}>
			{children}
		</span>
	) : (
		<div className={className} onClick={onClick} style={flexBoxStyle} onScroll={onScroll} ref={ref}>
			{children}
		</div>
	);
};
export default FlexBox;
